<template>
  <div class="contain">

    <div class="bg-white pt-23  mb-24">
      <!-- B 情况 -->
      <div class="head pb-16 px-12">
        <div class="title">
          <div class="text">{{ params_all.projectname }}</div>
          <div class="righttext flex-none" v-if="params_all.deduction == 0">
            <div class="no-de">未扣分</div>
          </div>
          <div class="righttext" v-else>
            <div class="branch">-{{ (params_all.deduction || 0) / 100 }}</div>
          </div>
        </div>
        <div class="text-12 text-[#999999]">{{ params_all.areaName }} {{ params_all.quarterName }}</div>
      </div>
    </div>

    <!-- 考核信息 -->
    <div class="mx-12 mb-16" ref="dialogWrapper">
      <div class=" mt-24 mb-12   flex flex-row gap-4 items-end">
        <div class="text-[#333333] text-16 font-bold">考评信息</div>
        <van-popover v-model="showPopover" trigger="click" theme="dark" placement="bottom-start" :offset="[-10, 16]">
          <div class="text-12 px-8 py-12   text-[#e4e3e3]"
               v-if="params_all.dealType == 'B1' || params_all.dealType == 'B2'">
            扣分规则：每件扣0.25分，上限2.5分
          </div>
          <div class="text-12 px-8 py-12  min-w-60 text-[#e4e3e3]" v-else>
            扣分规则：区域24小时办结率低于95％，扣1分
          </div>
          <template #reference>
            <img src="@/assets/appraise/ic_appraise_help.png" class="size-12 object-scale-down"/>
          </template>
        </van-popover>

      </div>
      <div class="card-bg">
        <div class="flex-col ">
          <div class="" v-if="Number(params_all.deduction) > 0 && params_all.dealType == 'B1'">扣分原因：5分钟内未响应{{
              params_all.respoutNum
            }}件，扣{{ (params_all.deduction || 0) / 100 }}分
          </div>
          <div class="" v-else-if="Number(params_all.deduction) > 0 && params_all.dealType == 'B2'">扣分原因：24小时未办结{{
              params_all.doneoutNum
            }}件，扣{{ (params_all.deduction || 0) / 100 }}分
          </div>
          <div v-else class="mx-auto my-0 w-full flex justify-center items-center">
            暂无数据
          </div>
        </div>
      </div>

    </div>

    <div class="mx-12 mb-16" v-if="subList.length">
      <div class=" mt-24 mb-12 text-[#333333] text-16  font-bold">
        <span v-if="params_all.dealType == 'B1'"> 5分钟内未响应明细</span>
        <span v-if="params_all.dealType == 'B2'"> 24小时未办结明细</span>
        <span v-if="params_all.dealType == 'B3'"> 投诉办结情况</span>
      </div>
    </div>

    <!-- 明细列表 -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" offset="1" @load="initData"
              v-if="subList.length && params_all.dealType != 'B3'">
      <div class="content">
        <div class="record-item-cont" v-for="(item, index) in subList" :key="index">
<!--          <div class="line">-->
<!--            <div class="txt">-->
<!--              <span class="txt-tit">扣分原因：</span>-->
<!--              <span class="txt-cont">{{ item.deductionReason }}</span>-->
<!--            </div>-->
<!--            <div class="right-txt-line">-->
<!--              <div class="score" :class="item.isExceed == 1 && index ==0 ? 'txtDec' : ''">-{{ item.deductionStr }}分</div>-->
<!--              <div class="timememo" v-if="item.isExceed == 1 && index ==0 ">已达扣分上限</div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="line" v-if="params_all.dealType === 'B1'">
            <div class="txt">
              <span class="txt-tit">响应时长：</span>
              <span class="txt-cont">{{ item.answerTime | timeStamp }}</span>
            </div>
          </div>
          <div class="line" v-if="params_all.dealType === 'B2'">
            <div class="txt">
              <span class="txt-tit">州市办结时长：</span>
              <span class="txt-cont">{{ item.dealDurationCN }}</span>
            </div>
          </div>

          <div class="line" >
            <div class="txt">
              <span class="txt-tit">投诉时间：</span>
              <span class="txt-cont">{{ item.complainTime | filt }}</span>
            </div>
          </div>
          <div class="line" v-if="params_all.dealType === 'B1'" >
            <div class="txt">
              <span class="txt-tit">响应时间：</span>
              <span class="txt-cont">{{ item.respondTime | filt }}</span>
            </div>
          </div>
          <div class="line" v-if="params_all.dealType === 'B2'">
            <div class="txt">
              <span class="txt-tit">办结时间：</span>
              <span class="txt-cont">{{ item.finishTime }}</span>
            </div>
          </div>
          <div class="line">
            <div class="txt">
              <span class="txt-tit">所属地区：</span>
              <span class="txt-cont">{{ item.incidentBefallCityName }}</span>
            </div>
          </div>
          <div class="line" >
            <div class="txt">
              <span class="txt-tit">投诉单号：</span>
              <span class="txt-cont">{{ item.orderNo }}</span>
            </div>
          </div>
          <div class="line" @click="navToDetail(item)">
            <div class="to-detail">
              <div class="w-120">投诉详情</div>
              <img src="@/assets/image/tb-right.png"/>
            </div>
          </div>
        </div>
      </div>
    </van-list>

    <!-- B3 投诉办结情况的图标 -->
    <!-- <div v-if="params_all.dealType == 'B3'" class="mt-12 px-12 flex flex-col">
      <div class="bg-white mt-12 rounded-4 shadow-sm">
        <div class="grid grid-cols-3 border-0 border-solid border-b border-b-[#EEEEEE]">
          <div
            class="flex-1 flex flex-col items-center justify-center py-16 border-0 border-solid border-r border-r-[#EEEEEE]">
            <div class="text-12 text-[#333333] font-400">投诉件总数</div>
            <div class="text-20 text-[#36B374] font-700 mt-8">
              {{ "sss" }}
              <span class="text-10 text-[#36B374] font-400">件</span>
            </div>
          </div>

          <div
            class="flex-1 flex flex-col items-center justify-center py-16 border-0 border-solid border-r border-r-[#EEEEEE]">
            <div class="text-12 text-[#333333] font-400">24小时内办结数量</div>
            <div class="text-20 text-[#36B374] font-700 mt-8">
              {{ "100" }}
              <span class="text-10 text-[#36B374] font-400">件</span>
            </div>
          </div>
          <div class="flex-1 flex flex-col items-center justify-center py-16 ">
            <div class="text-12 text-[#333333] font-400">24小时内未办结数量</div>
            <div class="text-20 text-[#36B374] font-700 mt-8">
              {{ unsatisfiedNum }}
              <span class="text-10 text-[#36B374] font-400">件</span>
            </div>
          </div>

        </div>
        <div class="container mx-auto">
          <div class="text-center flex items-center justify-center py-12" @click="gotoComplainList">
            <span>查看投诉件列表</span>
            <img src="@/assets/appraise/ic_right.png" class="size-8 object-scale-down ml-4 " />
          </div>

        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// 扣分记录列表
import APIS from "@/service/index";

export default {
  name: "causeDeduction",
  data() {
    return {
      onHide: false,
      subList: [],
      subName: "",
      subType: "",
      params_all: {...this.$route.query},
      finished: false,
      loading: false,
      currentPage: 0,
      showPopover: false,
    };
  },
  methods: {

    getComplainByB1() {
      // {year: 2020, quarter: 3, area: 530100, currentPage: 1, pageSize: 5}
      const _this = this;
      return new Promise((resovle, reject) => {
        _this.loading = true;
        // _this.finished = false;
        let params = {
          currentPage: _this.currentPage,
          pageSize: 20,
          data:{
            area: _this.params_all.area,
            year: _this.params_all.year,
            quarter: _this.params_all.quarter,
            complainType:1,
          }
        };
        APIS.getCityComplainDealPageList(params).then((res) => {
          // console.log("----获取的数据B1:", res);
          // _this.subList = [];
          if (res.ret == 0) {

            if (res.data.content && res.data.content.length > 0) {
              _this.subList.push(...res.data.content);
              _this.loading = false;
              // console.log('-----这个数据的长度：', _this.subList.length);
              if (res.data.totalElements <= _this.subList.length) {
                _this.finished = true;
              }
            }
          } else {
            _this.loading = false;
            _this.finished = true;
          }
          resovle(true);
        });
      });
    },
    getComplainByB2() {
      const _this = this;
      return new Promise((resolve, reject) => {
        _this.loading = true;
        _this.finished = false;
        let params = {
          currentPage: _this.currentPage,
          pageSize: 20,
          data:{
            area: _this.params_all.area,
            year: _this.params_all.year,
            quarter: _this.params_all.quarter,
            complainType:2,
          }
        };
        APIS.getCityComplainDealPageList(params).then((res) => {
          // console.log("-----获取的数据B2：", res);
          // _this.subList = [];
          if (res.ret == 0) {
            _this.deductionScore += res.data.deduction / 100;
            if (res.data && res.data.content && res.data.content.length > 0) {
              _this.subList.push(...res.data.content);
              _this.loading = false;
              if (res.data.totalElements <= _this.subList.length) {
                _this.finished = true;
              }
            } else {
              _this.loading = false;
              _this.finished = true;
            }
          }
          resolve(true);
        });
      });
    },
    getComplainByB3() {
      const _this = this;
      return new Promise((resolve, reject) => {
        _this.loading = true;
        _this.finished = false;
        api.getComplainByB3(this.params_all).then((res) => {
          // console.log("-----获取的数据B3：", res);
          // _this.subList = [];
          if (res.ret == 0) {
            _this.deductionScore += res.data.deduction / 100;
            if (res.data.resVOS.content && res.data.resVOS.content.length > 0) {
              _this.subList.push(...res.data.resVOS.content);
              _this.loading = false;
              if (res.data.resVOS.totalElements <= _this.subList.length) {
                _this.finished = true;
              }
            }
          }
          resolve(true);
        });
      });
    },
    initData() {
      this.currentPage += 1;
      this.$set(this.params_all, "pageSize", this.pageSize);
      const {dealType} = this.$route.query;
      if (dealType === "B1") {
        this.getComplainByB1();
      } else if (dealType === "B2") {
        this.getComplainByB2();
      } else if (dealType === "B3") {
        this.getComplainByB3();
      }
    },
    // gotoComplainList() {
    //   this.$router.push({
    //     path: '/appraise/complainList',
    //     query: {
    //       year: this.$route.query.year,
    //       cityId: this.$route.query.area,
    //       quarter: this.$route.query.quarter,
    //     }
    //   })
    // },
    // 跳转详情页
    navToDetail(item) {
      const {year, areaName, quarter} = this.$route.query;
      console.log("🚀 ~ navToDetail ~ complaint:", `mainComplainNumber=${item.orderNo}&complainNumber=${item.orderSubNo}&subID=${item.id}`)
      if (this.params_all.dealType === 'B1' || this.params_all.dealType === 'B2') {
        // this.$router.push({
        //   path: "/appraise/fiveMunites",
        //   query: {
        //     orderNo: item.orderNo,
        //     orderSubNo: item.orderSubNo,
        //     year: year,
        //     areaName: areaName,
        //     quarter: quarter,
        //     isExceed: item.isExceed
        //   },
        // });
        // let query = {
        //   complainNumber: item.orderSubNo,
        //   mainComplainNumber: item.orderNo,
        // };

        // this.$router.push({
        //   name: "assessDetails",
        //   query,
        // });
        // util.setJsonLocal("item", query);
        // yyngov://complaint?path=complain_detail_container&mainComplainNumber=202403111621102494211&complainNumber=2024031116211024942110000&subID=8db15cc3c8fa48fab51eab9a55f8d672&messageId=1389700&isRead=false
        window.yyn.invokeJSB(
            "openWindow",
            {
              openUrl: `yyngov://complaint?path=complain_detail_container&mainComplainNumber=${item.orderNo}&complainNumber=${item.orderSubNo}&subID=${item.id}`,
              isFullScreen: 0,
              setTitle: "",
              needLoading: 1,
            },
            (cb) => {
              console.log(cb, "openWindow");
            })
      } else if (item.dealType === "B3") {
        this.$router.push({
          path: "/appraise/nintyFivePercent",
          query: {
            id: item.id,
            year: year,
            areaName: areaName,
            quarter: quarter,
            isExceed: item.isExceed
          },
        });
      }
    },
  },
  mounted() {
    console.log('output->[ mounted ] >', this.$route.query)
    // window.yyn.invokeJSB(
    //   "setTitle",
    //   {
    //     title: sessionStorage.getItem("projectName") || "扣分列表",
    //   },
    //   (cb) => {}
    // );
    this.initData();
  },
  filters: {
    filt(value) {
      if (value) {
        return value;
      } else {
        return '未响应'
      }
    },
    timeStamp( second_time ){
      if(second_time == null || isNaN(second_time)) return "--秒"
      var time = parseInt(second_time) + "秒";
      if( parseInt(second_time )> 60){
        var second = parseInt(second_time) % 60;
        var min = parseInt(second_time / 60);
        time = min + "分" + second + "秒";
        if( min > 60 ){
          min = parseInt(second_time / 60) % 60;
          var hour = parseInt( parseInt(second_time / 60) /60 );
          time = hour + "小时" + min + "分" + second + "秒";
          if( hour > 24 ){
            hour = parseInt( parseInt(second_time / 60) /60 ) % 24;
            var day = parseInt( parseInt( parseInt(second_time / 60) /60 ) / 24 );
            time = day + "天" + hour + "小时" + min + "分" + second + "秒";
          }
        }
      }
      return time;
    },
  }
};
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #eee;

  .title {
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    min-height: 42.98px;

    .righttext {
      text-align: right;
    }

    .isaudied {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 140, 25, 1);
      line-height: 28px;
    }

    .text {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
      padding-right: 50px;
    }

    .score-div {
      font-size: 14px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
      line-height: 14px;
      margin-top: 8px;
    }

    .branch {
      height: 22px;
      font-size: 22px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: rgba(255, 77, 77, 1);
      line-height: 28px;
    }

    .no-de {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(54, 179, 116, 1);
      line-height: 22px;
    }
  }
}

.card-bg {
  background-color: #fff;
  padding-top: 16px;
  padding-bottom: 16px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  padding-left: 12px;
  padding-right: 12px;
}

.contain {
  min-height: 100vh;
  padding-bottom: 24px;
  background: #fbfbfb;

  .content {
    margin: 0 12px;
    height: auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;

    .record-item-cont {
      line-height: 20px;
      transition: all 0.2s;
      border-bottom: solid 1Px #EEEEEE;
      padding: 12px 16px;

      .line {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 8px;

        // line-height: 20px;
        // height: 20px;
        .txt {
          display: flex;

          &-tit {
            // width: 60px;
          }

          &-cont {
            width: 192px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        .score {
          color: #ff4d4d;
        }

        .to-detail {
          position: relative;
          color: #36b374;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 4px;
          height: 12px;
          width: 150px;

          div {
            position: absolute;
            left: 0;
            top: 0;
            width: 50px;
            line-height: 12px;
          }

          img {
            position: absolute;
            left: 50px;
            top: -1px;
            width: 12px;
            height: 12px;
          }
        }
      }

      .line:last-child {
        margin-bottom: 0;
      }
    }

    .record-item-cont:last-child {
      border-bottom: 0;
    }

    .ts-list {
      padding-top: 12px;
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(155, 155, 155, 1);
      line-height: 17px;

      span {
        padding-right: 10px;
        background: url("../../../../assets/image/t-right.png") no-repeat;
        background-size: 8px 8px;
        background-position: right center;
      }
    }
  }

  .right-txt-line {
    position: relative;
  }

  .txtDec {
    text-decoration: line-through;
  }

  .timememo {
    color: #ff8c19;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    // text-align: right;
    width: 100px;
    margin-top: 6px;
    position: absolute;
    right: -30px;
    top: 14px;
  }
}
</style>
